import { Branding } from "@/helper";
import { Route } from "vue-router";

export interface SignupData {
  ContactId: number | null;
  Title: string | null;
  Forename: string | null;
  Surname: string | null;
  Email: string | null;
  CompName: string | null;
  PhoneNumber: string | null;
  Password: string | null;
  Type: string | null;
  VerifyCode: string | null;
  Location: LocationFromIP | null;
  UTMDictionary: Record<string, string>;
  FreeTrialCode: string | null;
  Branding: string | null;
  Industry: IndustryItem | null;
}
export interface Country {
  CountryCode: string;
  CountryName: string;
}

export interface LocationFromIP {
  CountryRegion: IPCountryRegion | null;
}

export interface IPCountryRegion {
  IsoCode: string | null;
}
export interface IndustryItem {
  Name: string;
  StandardIndustryCode?: string;
  SubIndustries?: IndustryItem[];
  StockedProducts: boolean;
  IsServices?: boolean;
}

export enum SignupFlow {
  ProspectSignup = 1,
  AccessIdentity = 2,
}

export enum SignupBranding {
  ProspectCRM = 1,
  AccessCRM = 2,
}

export function getCurrentSignupFlow(route: Route) {
  const enumKey = route.query.signupFlow as keyof typeof SignupFlow;
  return enumKey ? SignupFlow[enumKey] || null : null;
}

export function getSignupBranding() {
  const enumKey = Branding.getBranding() as keyof typeof SignupBranding;
  return SignupBranding[enumKey] || SignupBranding.ProspectCRM;
}

export function getSignupFlow(code: string) {
  return (
    parseNumberToEnum(+code.split("-")[1], SignupFlow) ||
    SignupFlow.ProspectSignup
  );
}

function parseNumberToEnum<TEnum extends object>(
  value: number,
  enumObj: TEnum
) {
  if (isNaN(value)) {
    return undefined;
  }

  if (Object.values(enumObj).includes(value)) {
    return value as unknown as TEnum[keyof TEnum];
  }

  return undefined; // or handle the case where it doesn't match
}
